import React from 'react';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { useBreadcrumbs, useRedirectHomeAccess } from '@/modules/core/hooks';
import { PlansList } from '@/modules/plan';
import { PLANS_ACCESS_REQUIREMENTS } from '@/modules/plan/hooks/usePlansAccess';

const PlansPage = () => {
  useRedirectHomeAccess(PLANS_ACCESS_REQUIREMENTS);

  useBreadcrumbs([
    {
      route: ROUTES.PLANS,
      title: 'Plans',
    },
  ]);

  return (
    <Box width="100%">
      <PlansList />
    </Box>
  );
};

export default PlansPage;
